import React, { useState } from 'react';  
import { Link, Navigate, useNavigate } from 'react-router-dom';  
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight, FiAlertCircle } from 'react-icons/fi';  
import { usePortalAuth } from '../../context/PortalAuthContext';  
import '../auth/auth.css';  
  
const PortalLoginPage = () => {  
  const { user, loading: authLoading, login } = usePortalAuth();  
  const navigate = useNavigate();  
  
  const [email, setEmail] = useState('');  
  const [password, setPassword] = useState('');  
  const [showPassword, setShowPassword] = useState(false);  
  const [error, setError] = useState('');  
  const [loading, setLoading] = useState(false);  
  
  const role = user?.role_slug || user?.role || '';  
  const isPortalUser = ['client', 'locataire'].includes(role);  
  
  if (!authLoading && user && isPortalUser) {  
    return <Navigate to="/portal/dashboard" replace />;  
  }  
  
  const handleSubmit = async (e) => {  
    e.preventDefault();  
    setError('');  
    setLoading(true);  
  
    try {  
      const data = await login(email, password);  
  
      const userRole = data.user?.role_slug || data.user?.role || '';  
      if (!['client', 'locataire'].includes(userRole)) {  
        setError('Ce compte n\'a pas accès au portail.');  
        return;  
      }  
  
      navigate('/portal/dashboard', { replace: true });  
    } catch (err) {  
      setError(err.response?.data?.error || 'Email ou mot de passe incorrect');  
    } finally {  
      setLoading(false);  
    }  
  };  
  
  return (  
    <div className="auth-wrapper">  
      <div className="auth-left">  
        <div className="auth-left-content">  
          <div className="auth-brand">  
            <div className="auth-brand-icon">🏠</div>  
            <div className="auth-brand-name">Portail<span>Client</span></div>  
          </div>  
  
          <h2>Accédez à vos factures et paiements</h2>  
          <p>Consultez vos échéances, suivez vos paiements et recevez vos notifications dans un espace dédié.</p>  
  
          <ul className="auth-features-list">  
            <li>  
              <div className="auth-feature-icon">•</div>  
              Consultation des factures et loyers  
            </li>  
            <li>  
              <div className="auth-feature-icon">•</div>  
              Paiement sécurisé en ligne  
            </li>  
            <li>  
              <div className="auth-feature-icon">•</div>  
              Notifications et historique  
            </li>  
          </ul>  
        </div>  
      </div>  
  
      <div className="auth-right">  
        <div className="auth-right-header">  
          <h1>Connexion portail</h1>  
          <p>Connectez-vous pour accéder à votre espace client / locataire</p>  
        </div>  
  
        {error && (  
          <div className="auth-alert-error">  
            <FiAlertCircle size={16} />  
            {error}  
          </div>  
        )}  
  
        <form className="auth-form" onSubmit={handleSubmit}>  
          <div className="form-group">  
            <label>Adresse email</label>  
            <div className="auth-input-wrapper">  
              <FiMail size={16} className="auth-input-icon" />  
              <input  
                type="email"  
                className="form-control"  
                value={email}  
                onChange={(e) => setEmail(e.target.value)}  
                placeholder="votre@email.com"  
                required  
                autoComplete="email"  
              />  
            </div>  
          </div>  
  
          <div className="form-group">  
            <label>Mot de passe</label>  
            <div className="auth-input-wrapper">  
              <FiLock size={16} className="auth-input-icon" />  
              <input  
                type={showPassword ? 'text' : 'password'}  
                className="form-control"  
                value={password}  
                onChange={(e) => setPassword(e.target.value)}  
                placeholder="••••••••"  
                required  
                autoComplete="current-password"  
              />  
              <button  
                type="button"  
                className="auth-password-toggle"  
                onClick={() => setShowPassword(!showPassword)}  
                tabIndex={-1}  
              >  
                {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}  
              </button>  
            </div>  
          </div>  
  
          <button type="submit" className="auth-btn-primary" disabled={loading}>  
            {loading ? 'Connexion en cours...' : (  
              <>  
                Se connecter  
                <FiArrowRight size={18} />  
              </>  
            )}  
          </button>  
        </form>  
  
        <div className="auth-divider">ou</div>  
  
        <div className="auth-footer-link">  
          <Link to="/login">Retour à la connexion agence</Link>  
        </div>  
  
        <div className="auth-footer-link" style={{ marginTop: 12 }}>  
          <Link to="/" style={{ color: 'var(--auth-gray)', fontSize: 13 }}>← Retour à l'accueil</Link>  
        </div>  
      </div>  
    </div>  
  );  
};  
  
export default PortalLoginPage;